require('./bootstrap');

const sideMenuItems = document.querySelectorAll('.sidemenu a');
if ( sideMenuItems ) {
    sideMenuItems.forEach(item=>{
        if (item.href === window.location.href) {
            item.classList.add('active');
        }
        if ( item.href === location.origin + location.pathname ) {
            item.classList.add('active');
        }
    })
}

window.submitItem = function (obj) {
    window.event.preventDefault();
    const fd = new FormData(obj);
    axios.post(obj.action, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function (r) {
            obj.position.value = '';
            obj.name.value = '';
            obj.photo.value = '';
            alert('저장 완료!');
        })
        .catch(function (err) {
            console.error(err.response ? err.response : err);
        })
};

window.editItem = function (action) {

    axios.get(action)
        .then(function (r) {
            const d = r.data;

            // $('#add-form').collapse('show');
            const addForm = document.querySelector('#add-form');
            bootstrap.Collapse.getInstance(addForm).show();

            let f = document.querySelector('#commitee-form');
            f.action = '/commitee/' + r.data.id;
            for (let key in d) {
                if (null !== f.querySelector('input[name="' + key + '"]')) {
                    f.querySelector('input[name="' + key + '"]').value = d[key];
                }
                if (null !== f.querySelector('select[name="' + key + '"]')) {
                    f.querySelector('select[name="' + key + '"]').value = d[key];
                }

            }
        })
        .catch(function (err) {
            console.log(err.response ?? err);
        });
};

window.deleteItem = function (obj, action) {
    const item = obj.closest('.photo');
    if (!confirm('정말로 삭제할까요?')) return false;

    axios.delete(action)
        .then(function (r) {
            item.remove();
        })
        .catch(function (err) {
            console.error(err.response ? err.response : err);
        });
}


// 폼 전송 시 처리 액션 모음
window.submitSubmitter = (submitter) => {
    submitter.setAttribute('disabled', '');
    submitter.textContent = '저장 중...';
}

window.resetSubmitter = (submitter) => {
    submitter.removeAttribute('disabled');
    submitter.textContent = '저장';
}

window.resetInvalidItems = (formObj) => {
    formObj.querySelectorAll('.is-invalid, .invalid-feedback').forEach(el=>{
        if ( el.classList.contains('is-invalid') ) {
            el.classList.remove('is-invalid');
        } else {
            el.remove();
        }
    })
}

window.setFeedback = (message) => {
    const el = document.createElement('div');
    el.classList.add('invalid-feedback');
    el.textContent = message;

    return el;
}

window.formErrorHandler = (formObj, err) => {
    if ( err.response?.status === 422 ) {

        const {errors} = err.response.data;
        console.log(errors);

        for(let key in errors) {
            const el = formObj.querySelector(`[name="${key}"]`);
            const feedbackEl = setFeedback(errors[key][0]);
            el.closest('.form-wrap').appendChild(feedbackEl);

            if ( el.type && el.type === ('radio'||'checkbox') ) {
                formObj.querySelectorAll(`[name="${key}"]`).forEach(elm=>{
                    elm.classList.add('is-invalid');
                })
            } else {
                el.classList.add('is-invalid');
            }
        }

        formObj.querySelector('.is-invalid').focus();

    } else if ( err.response?.status === (401||403) ) {
        alert(`권한 없음\n\n${err.response?.data.message ?? err.message}`);
    } else {
        alert(`오류\n\n${err.response?.data.message ?? err.message}`)
    }
}
